import React from 'react';

import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { formatSeparatedTimeFromSeconds, SeparatedDate } from '@utils/date';
import { getTimeWord } from '@utils/getTimeWord';

import * as Styled from './timer.styled';

type OwnProps = {
	time: string;
};

const Timer: React.FC<OwnProps> = ({ time }) => {
	const timerRef = React.useRef<any>(null);
	const timeNumber: number = dayjs(time).diff(dayjs(), 'seconds');
	const [formattedDate, setFormattedDate] = React.useState<SeparatedDate>();
	const [currentSeconds, setCurrentSeconds] = React.useState(timeNumber);
	const { t } = useTranslation('main');

	React.useEffect(() => {
		if (timeNumber > 0) {
			setFormattedDate(formatSeparatedTimeFromSeconds(currentSeconds));
		}
	}, [currentSeconds, timeNumber]);

	React.useEffect(() => {
		if (timeNumber > 0 && timeNumber) {
			timerRef.current = setInterval(() => {
				setCurrentSeconds(prev => Math.max(prev - 1, 0));
			}, 60000);
		}

		return () => clearInterval(timerRef.current);
	}, [timeNumber]);

	return (
		formattedDate && (
			<Styled.Wrapper>
				<Styled.TimeColumn>
					<Styled.TimeNumber>{formattedDate.days}</Styled.TimeNumber>
					<Styled.TimeWord>{getTimeWord(+formattedDate.days, 'day', t)}</Styled.TimeWord>
				</Styled.TimeColumn>
				<Styled.Divider>:</Styled.Divider>
				<Styled.TimeColumn>
					<Styled.TimeNumber>{formattedDate.hours}</Styled.TimeNumber>
					<Styled.TimeWord>{getTimeWord(+formattedDate.hours, 'hour', t)}</Styled.TimeWord>
				</Styled.TimeColumn>
				<Styled.Divider>:</Styled.Divider>
				<Styled.TimeColumn>
					<Styled.TimeNumber>{formattedDate.minutes}</Styled.TimeNumber>
					<Styled.TimeWord>{getTimeWord(+formattedDate.minutes, 'minute', t)}</Styled.TimeWord>
				</Styled.TimeColumn>
			</Styled.Wrapper>
		)
	);
};

export default Timer;
